import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ToolTip from 'react-bootstrap/Tooltip';

function TooltipComponent(props) {
  // ['top', 'right', 'bottom', 'left']

  return (
    <OverlayTrigger placement={props.placement} overlay={
      <ToolTip id={`tooltip-${props.placement}`}> {props.tooltipText} </ToolTip>} >
      {props.children}
    </OverlayTrigger>
  );
}

export default TooltipComponent;